/**
 * Single source of truth for brand-level facts that were previously
 * hand-copied into all six HTML files. Anything that appears in more than
 * one place on the site belongs here, not in a component.
 */

export const site = {
  name: 'Abode Custom Homes',
  shortName: 'Abode',
  founded: 2026,
  tagline:
    'Crafting custom dream homes with quality craftsmanship tailored just for you. Your vision, our expertise.',
  location: 'Bloomington, IL',
  locationLong: 'Bloomington, Illinois',
  serviceArea: 'Serving Bloomington-Normal & McLean County',
  url: 'https://abodecustomhomes.com',
};

/**
 * Real contact details — this is a live business number, not a placeholder.
 * Kept in one place so the site can never show two different numbers.
 *
 * `phone` is the display form and `phoneHref` the dialable one; they must
 * always describe the same number. Keep phoneHref in E.164 (+1 and digits
 * only) so it dials correctly from a phone abroad.
 */
export const contact = {
  phone: '(309) 831-9216',
  phoneHref: 'tel:+13098319216',
  email: 'home@abodecustomhomes.com',
  emailHref: 'mailto:home@abodecustomhomes.com',
};

export const hours = [
  { days: 'Mon–Fri', time: '8am – 5pm' },
  { days: 'Sat', time: 'By appointment' },
];

export const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/process', label: 'Process' },
  { to: '/projects', label: 'Projects' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

/** The footer omits Home — the brand lockup above it already goes there. */
export const footerLinks = [
  { to: '/process', label: 'Our Process' },
  { to: '/projects', label: 'Projects' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];
